// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2DDB7","buttons":"SendReceipts_buttons__FTUA-","email":"SendReceipts_email__3Th70","bookApptTitle":"SendReceipts_bookApptTitle__3YvIS"};